import { FunctionComponent } from "react"
import SlimTile from "src/components/generic/tiles/SlimTile";

interface IConfirmFormSubmissionProps {
    values: Record<string, any>
}

const ConfirmFormSubmission: FunctionComponent<IConfirmFormSubmissionProps> = ({ values }) => (
    <div className="grid grid-cols-3 gap-8">
        <SlimTile>
            <h3 className="text-xl underline font-bold">Basic Information:</h3>
            <p className="mb-3"><b>Name:</b> {values?.name}</p>
            <p className="mb-3"><b>Email:</b> {values?.email}</p>
            <p className="mb-3"><b>Birthday:</b> {values?.dob}</p>
            <p className="mb-3"><b>Phone:</b> {values?.phone}</p>
            <p><b>Address:</b> {values?.address}</p>
            <p className="mb-3">{values?.city},{values?.state} {values.zip}</p>
            <p className="mb-3"><b>Gender:</b> {values?.gender}</p>
            <p className="mb-3"><b>Accepted Terms & Conditions:</b> {values?.termsAndConditions ? "Yes" : "No"}</p>
        </SlimTile>

        <SlimTile>
            <h3 className="text-xl underline font-bold">Financial Knowledge:</h3>
            <p className="mb-3"><b>Debt-to-Income Familiarity:</b> {values?.familiarWithD2I}</p>
            <p className="mb-3"><b>Has Budget or Plan:</b> {values?.financialPlanInPlace}</p>
            <p className="mb-3"><b>Experience Level:</b> {values?.experienceLevel}</p>
            <p className="mb-3"><b>Attended Course/Workshop:</b> {values?.attendedCoursesOrWorkshops}</p>
            <p className="mb-3"><b>Worked with Advisor:</b> {values?.workedWithAdvisor}</p>
            <p className="mb-3"><b>Using Tools or Apps:</b> {values?.usingToolsOrApps}</p>
            <p className="mb-3"><b>Saving for Retirement:</b> {values?.savingForRetirement}</p>
            <p className="mb-3"><b>Amount per Month (if applicable):</b> {values?.amountPerMonth}</p>
        </SlimTile>

        <SlimTile>
            <h3 className="text-xl underline font-bold">Employment Information:</h3>
            <p className="mb-3"><b>Employment Status:</b> {values?.employmentStatus}</p>
            <p className="mb-3"><b>Employment Duration (if applicable):</b> {values?.employmentDuration}</p>
            <p className="mb-3"><b>Living Status:</b> {values?.livingStatus}</p>
            <p className="mb-3"><b>Address Duration:</b> {values?.addressDuration}</p>
            <p className="mb-3"><b>Future Income Changes:</b> {values?.changesToIncomeOverYear}</p>
            <p className="mb-3"><b>Willing to Provide Documentation:</b> {values?.documentationConsent}</p>
            <p className="mb-3"><b>Additional Sources of Income:</b> {values?.additionalIncome}</p>
        </SlimTile>

        <SlimTile>
            <h3 className="text-xl underline font-bold">Lending Purpose:</h3>
            <p className="mb-3"><b>Seeking Loan:</b> {values?.seekingLoan}</p>
            <p className="mb-3"><b>Loan Type (if applicable):</b> {values?.loanType}</p>
            <p className="mb-3"><b>Loan Amount:</b> {values?.loanamount}</p>
            <p className="mb-3"><b>Open to Alternatives:</b> {values?.openToExploring}</p>
            <p className="mb-3"><b>Open to Government Backed Loans:</b> {values?.governmentBackedLoans}</p>
            <p className="mb-3"><b>Concerned with Loan Process:</b> {values?.activeConcerns}</p>
            <p className="mb-3"><b>Reason for Concern (if applicable):</b> {values?.reasonforconcerns}</p>
        </SlimTile>

        <SlimTile>
            <h3 className="text-xl underline font-bold">Financial History:</h3>
            <p className="mb-3"><b>Credit Pull Past 12 Months:</b> {values?.checkedCreditInLastYear}</p>
            <p className="mb-3"><b>Ever Applied for Loan:</b> {values?.applied}</p>
            <p className="mb-3"><b>Ever Denied for Loan:</b> {values?.denied}</p>
            <p className="mb-3"><b>Foreclosure, Repossession, Declared Bankruptcy, or Tax issues:</b> {values?.foreclosureOrDefault}</p>
            <p className="mb-3"><b>Reason (if applicable):</b> {values?.reason}</p>
            <p className="mb-3"><b>Co-Signer or Guarantor on Past Loan:</b> {values?.cosignerOrGuaranteeForClient}</p>
            <p className="mb-3"><b>Co-Signed or Guaranteed Loan:</b> {values?.cosignerOrGuaranteeForOther}</p>
            <p className="mb-3"><b>Collections or Judgements:</b> {values?.collectionsOrJudgements}</p>
            <p className="mb-3"><b>Behind on Payments:</b> {values?.behindOnPayments}</p>
            <p className="mb-3"><b>More than 30% Credit Use:</b> {values?.using30Percent}</p>
            <p className="mb-3"><b>Student Loan Debt:</b> {values?.studentLoanDebt}</p>
            <p className="mb-3"><b>Aware of Current Credit Score:</b> {values?.awareOfCreditScore}</p>
            <p className="mb-3"><b>Placed Block on Credit:</b> {values?.placedBlockOnCredit}</p>
        </SlimTile>

        <SlimTile>
            <h3 className="text-xl underline font-bold">Financial Goals:</h3>
            <p className="mb-3"><b>Primary Financial Goal:</b> {values?.primaryGoal}</p>
            <p className="mb-3"><b>Steps to Improve:</b> {values?.stepsToImprove}</p>
            <p className="mb-3"><b>How Did You Hear About ClientVitals:</b> {values?.howToHear}</p>
            <p className="mb-3"><b>Experienced Financial Hardships:</b> {values?.experiencedHarships}</p>
            <p className="mb-3"><b>Percent of Income Towards Housing:</b> {values?.percentageIncome}</p>
            <p className="mb-3"><b>Timeline For Goals:</b> {values?.timeline}</p>
            <p className="mb-3"><b>Experienced Life Changes:</b> {values?.lifeChanges}</p>
            <p className="mb-3"><b>Life Change (if applicable):</b> {values?.lifeType}</p>
            <p className="mb-3"><b>Emergency Funds:</b> {values?.asideMoney}</p>
            <p className="mb-3"><b>Has Financial Support System:</b> {values?.supportSystem}</p>
            <p className="mb-3"><b>Expecting Large Expense within 12 Months:</b> {values?.largeExpense}</p>
            <p className="mb-3"><b>Has Dependents:</b> {values?.dependents}</p>
            <p className="mb-3"><b>Paying or Receiving Alimony or Child Support:</b> {values?.paying}</p>
            <p className="mb-3"><b>Support Type:</b> {values?.receiving}</p>
        </SlimTile>
    </div>
);

export default ConfirmFormSubmission;